if (!customElements.get("page-kospet-care")) {
  customElements.define(
    "page-kospet-care",
    class pageKospetCare extends HTMLElement {
      constructor() {
        super();
        this.$tabId = '';
        this.$ultimateTabId = '';
        this.$swiper = '';
        this.$isMobile = window.innerWidth <= 768;
      }

      initSection3() {
        const section3 = this.querySelector('.section3');
        const swiperContainer = this.querySelector('.section3 .swiper-container');
        if( this.$isMobile ) {
          new Swiper(swiperContainer, {
            slidesPerView: 'auto',
            spaceBetween: '6.4%',
            // loop: true,
            centeredSlides: true,
            pagination: {
              el: section3.querySelector('.swiper-pagination'),
              clickable: true,
            },
          });
        }
      }
      initSection4() {
        const section4 = this.querySelector('.section4');
        const swiperContainer = this.querySelector('.section4 .swiper-container');
        if( this.$isMobile ) {
          new Swiper(swiperContainer, {
            slidesPerView: 'auto',
            spaceBetween: '3.2%',
            loop: true,
            centeredSlides: true,
            pagination: {
              el: section4.querySelector('.swiper-pagination'),
              clickable: true,
            },
          });
        } else {
          const list = section4.querySelector('.content .list');
          const lastItem = list.querySelector('.item:last-child');
          const left = section4.querySelector('.svg-icon .left');
          const right = section4.querySelector('.svg-icon .right');
          const lastItemRight = lastItem.offsetLeft + lastItem.offsetWidth;
          const distanceFromParentRight = list.clientWidth - lastItemRight;
          right.addEventListener('click', () => {
            list.style.transform = `translateX(${distanceFromParentRight}px)`;
            right.classList.add('disabled');
            left.classList.remove('disabled');
          })
          left.addEventListener('click', () => {
            list.style.transform = `translateX(0px)`;
            left.classList.add('disabled');
            right.classList.remove('disabled');
          })
        }
      }
      initSection5() {
        const section5 = this.querySelector('.section5');
        const swiperContainer = this.querySelector('.section5 .swiper-container');
        let swiper = null;
        if( this.$isMobile ) {
          const list = section5.querySelector('.list');
          const items = list.querySelectorAll('.item');
          // if (items.length >= 2) {
          //   list.appendChild(items[1]);
          // }
          swiper = new Swiper(swiperContainer, {
            slidesPerView: 'auto',
            spaceBetween: '6.4%',
            // loop: true,
            autoHeight: true,
            centeredSlides: true,
            // observer: true,
            // observeParents: true,
            pagination: {
              el: section5.querySelector('.swiper-pagination'),
              clickable: true,
            },
            initialSlide: 1,
          });
          section5.querySelectorAll(".content .list .item").forEach(item => {
            const more = item.querySelector(".more div");
            const main = item.querySelector(".main");
            console.log(item, more)
            more.addEventListener("click", () => {
              const isOpen = main.classList.contains("expand");
              if (isOpen) {
                collapse(main);
                main.classList.remove("expand");
              } else {
                expand(main);
                main.classList.add("expand");
              }
            });
            function expand(el) {
              el.style.height = "0px";
              const height = el.scrollHeight;
              requestAnimationFrame(() => {
                el.style.height = height + "px";
              });
              let start = null;
              function updateHeight(timestamp) {
                if (!start) start = timestamp;
                swiper.updateAutoHeight(0);
                if (timestamp - start < 300) {
                  requestAnimationFrame(updateHeight);
                }
              }
              requestAnimationFrame(updateHeight);
              el.addEventListener(
                "transitionend",
                () => {
                  el.style.height = "auto";
                  swiper.updateAutoHeight(0);
                },
                { once: true }
              );
            }
            function collapse(el) {
              const height = el.scrollHeight;
              el.style.height = height + "px";
              if(el.classList.contains("shield")) {
                requestAnimationFrame(() => {
                  el.style.height = 556 / 375 * window.innerWidth + "px";
                });
              } else {
                requestAnimationFrame(() => {
                  el.style.height = 562 / 375 * window.innerWidth + "px";
                });
              }
              let start = null;
              function updateHeight(timestamp) {
                if (!start) start = timestamp;
                swiper.updateAutoHeight(0);
                if (timestamp - start < 300) {
                  requestAnimationFrame(updateHeight);
                }
              }
              requestAnimationFrame(updateHeight);
              el.addEventListener(
                "transitionend",
                () => {
                  swiper.updateAutoHeight(0);
                },
                { once: true }
              );
            }
          });
        }
      }
      initSection6() {
        const section6 = this.querySelector('.section6');
        section6.querySelectorAll(".content .list .item").forEach(item => {
          const question = item.querySelector(".question");
          const answer = item.querySelector(".answer");

          question.addEventListener("click", () => {
            const isOpen = item.classList.contains("open");
            if (isOpen) {
              collapse(answer);
              item.classList.remove("open");
            } else {
              expand(answer);
              item.classList.add("open");
            }
          });
          function expand(el) {
            el.style.height = "0px";
            const height = el.scrollHeight;
            requestAnimationFrame(() => {
              el.style.height = height + "px";
            });
            el.addEventListener(
              "transitionend",
              () => {
                el.style.height = "auto";
              },
              { once: true }
            );
          }

          function collapse(el) {
            const height = el.scrollHeight;
            el.style.height = height + "px";
            requestAnimationFrame(() => {
              el.style.height = "0px";
            });
          }
        });
      }

      connectedCallback() {
        document.addEventListener("DOMContentLoaded", () => {
          this.initSection3();
          this.initSection4();
          this.initSection5();
          this.initSection6();
          if (window.innerWidth > 768) {
          } else {
            // this.initSection3();
          }
        });
      }
    }
  );
}
